@if (isLoading) {
    <sb-loader></sb-loader>
} @else {
    <h4>{{ group.name }}</h4>

    @for (user of group.users; track user.id) {
        <div class="d-flex align-items-center panel-list-item">
            <sb-user-avatar
                class="user-avatar-sm pointer"
                [user]="user"
                [withRoleTooltip]="true"
                (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: user })"
                [size]="'small'">
            </sb-user-avatar>
            <div class="truncate">
                <div class="truncate">
                    {{ user.name }}
                </div>
                <div class="item-email truncate text-light">
                    {{ user.email }}
                </div>
            </div>
        </div>
    }
}
